<template>
  <div class="edit_attachment_bg">
  
    <div class="edit_attachment_content" id="editAttachmentBg"
    :style="{left:(0)+'px', height:(fullHeight)+'px'}"
    v-show="showAttachmentView">
        <div class="attachment-title-content">
          <div class="attachment-title" >附件资料</div>
           
          <a-icon class="view_close" type="close-circle" @click.stop="onClose"/>
          <a-icon class="view_add" type="plus-circle" @click.stop="addAttachment"/>
        </div>
        <div class="empty-view" v-show="mindAttachmentList.length == 0">没有附件/资料</div>
        <div
          class="list-content-cell"
          v-for="(item, index) in mindAttachmentList"
          :key="index"
          :class="index%2 == 0 ? 'list-content-cell-dark' : 'list-content-cell-light'"
          @click="setAttachmentData(index, item)">
          <div class="complie-content-icon-box" v-show="item.url != ''">
            <img :src="getFileIcon(item.type)" class="cell-icon"/>
            <div class="file-layout"> 
              <div class="file-name" >{{ item.name }}</div>
              <div class="file-des" >{{ getFileDes(item) }}</div>
            </div>
            <div class="delete_label" @click.stop="onDelete(item)">删除</div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import getString from '../../../common/lang/language.js';
import strings from '../../../common/lang/strings.js';
import ComplieChildMenuForm from "../ComplieRightMenuChild/ComplieChildMenuForm";
import ComplieChildMenuNodeQuickStyle from "../ComplieRightMenuChild/ComplieChildMenuNodeQuickStyle";
import EditMindmapVM from "../../../viewmodel/mindelementdata/vm/EditMindmapVM.js";
import ResourceType from "../../../viewmodel/datatype/ResourceType.js";
import httpImageToPrefix from '../../../utils/httpImageToPrefix.js';
import { getJwt, openSystemUrl } from "../../../common/netWork/base.js";
import LoadLocalXJMind from "../../../viewmodel/core/tools/mapfile/LoadLocalXJMind.js";
import Util from "../../../utils/Util.js";
if (
  typeof navigator === "object" &&
  typeof navigator.userAgent === "string" &&
  navigator.userAgent.indexOf("Electron") >= 0
) {
  var { ipcRenderer, remote } = window.require("electron");
}

export default {
  props: [
    "showAttachmentView",
    "attachmentDataList",
    "fullHeight",
    "fullWidth",    
  ],
  data() {
    return {
      strings:strings,
      mindRootId: "",
      mindSheetId: "",
      mindAttachmentList: [],
    };
  },
  created(){
    this.findResultTips = getString(this.strings.Global_Text_Find_Empty)
  },
  mounted(){
    this.dragDown1();
  },
  components: {
    ComplieChildMenuForm,
    ComplieChildMenuNodeQuickStyle,
    ResourceType
  },
  methods: {
    ...mapMutations([
      "useShortcut", 
      "setIsShowEditAttachmentView",
      "setResourceModelData",
      "showLoginModel",
    ]),
    getString(i){
      return getString(i)
    },
    onClose(){
      this.setIsShowEditAttachmentView(false);
    },

    getFileDes(item) {
      if (item.nodeId > -1) {
        return "主题：" + item.nodeText
      } else {
        return "文件附件"
      }
    },

    getFileIcon(type) {
      switch (type) {
        case ResourceType.WORD :
          return require("../../../assets/img/user/currency/file_type_doc.png")
        case ResourceType.EXCEL :
          return require("../../../assets/img/user/currency/file_type_xlsx.png")
        case ResourceType.PDF :
          return require("../../../assets/img/user/currency/file_type_pdf.png")
        case ResourceType.TXT :
          return require("../../../assets/img/user/currency/file_type_txt.png")
        case ResourceType.IMAGE :
          return require("../../../assets/img/user/currency/file_type_image.png")
        case ResourceType.VIDEO :
          return require("../../../assets/img/user/currency/file_type_video.png")
          case ResourceType.AUDIO :
          return require("../../../assets/img/user/currency/file_type_audio.png")
        default:
          return require("../../../assets/img/user/currency/file_type_attchment.png")
      }
    },

    httpImageToPrefix(src) {
      return httpImageToPrefix(src);
    },

    setAttachmentData(index, item) {
      if (item.url == "" || item.url == null) {
        return
      }
      let url = item.url
      //打开或者下载附件
      let downLink = this.httpImageToPrefix(url);
      if (this.$tools.isElectron()) {
        //打开浏览器啊下载
        var fs = window.require("fs");
        var path = window.require("path");
        let desdirpath = url.substring(0, url.lastIndexOf("/"));

        let desfilename = url.substring(url.lastIndexOf("/") + 1);
        desdirpath =
          desdirpath.indexOf("http") > -1
            ? desdirpath.replaceAll("://", "/")
            : desdirpath;
        desdirpath =
          desdirpath.indexOf(":") > -1
            ? desdirpath.replaceAll(":", "/")
            : desdirpath;
        let cacheDir = localStorage.getItem("cacheDir");
        let newDesdirpath;
        if (this.$tools.isWindows()) {
          newDesdirpath = desdirpath.replaceAll("/", "\\") + "\\" + desfilename;
          desdirpath = desdirpath.replaceAll("/", "\\");
          cacheDir = cacheDir.replaceAll("/", "\\");
          newDesdirpath = cacheDir + "\\" + newDesdirpath;
        } else {
          newDesdirpath = desdirpath.replaceAll("\\", "/") + "/" + desfilename;
          desdirpath = desdirpath.replaceAll("\\", "/");
          cacheDir = cacheDir.replaceAll("\\", "/");
          newDesdirpath = cacheDir + "/" + newDesdirpath;
        }
        if (LoadLocalXJMind.existsLocalFile(downLink)) {
            openSystemUrl(LoadLocalXJMind.getLocalFilePath(downLink, false));
        } else if (fs.existsSync(newDesdirpath)) {
          openSystemUrl(newDesdirpath);
        } else {
          let obj = {};
          obj.url = downLink;
          obj.desc = newDesdirpath;
          ipcRenderer.send("http-download-and-open", obj);
        }
      } else {
        window.open(downLink);
      }
    },

    setListData() {
      this.mindAttachmentList = EditMindmapVM.getAttachmentDatas()      
    },

    onDelete(item) {
      if (item.nodeId <= -1) {
          EditMindmapVM.deleteGlobalResource(item.url);
      } else {
          EditMindmapVM.deleteAttachment(item.nodeId, item.url);
      }
      for (let index = 0; index < this.mindAttachmentList.length; index++) {
        const data = this.mindAttachmentList[index];
        if (data.url == item.url) {
          this.mindAttachmentList.splice(index, 1)
          break;
        }
      }
    },

    addAttachment() {
      if (getJwt("jwt")) {
        let obj = {isShow: true, isGlobal: true, time: Util.getCurrentTime()}
        this.setResourceModelData(obj);
      } else {
        this.showLoginModel(true);
      }
    },

    dragDown1(){
      document.getElementById("editAttachmentBg").addEventListener("mousedown",this.dragDown);
    },
    dragDown:function(e){
      window.event ? window.event.cancelBubble = true : e.stopPropagation();
      let oDiv = document.getElementById("editAttachmentBg");
      let disX = e.clientX - oDiv.offsetLeft;
      let disY = e.clientY - oDiv.offsetTop;
      document.onmousemove = (el)=>{
        let left = el.clientX - disX;
        let top = el.clientY - disY;
        oDiv.style.left = left + 'px';
        oDiv.style.top = top + 'px';
      }

      document.onmouseup = (e)=>{
        document.onmousemove = null;
        document.onmouseup = null;
      }
    },
  },
  watch: {    
    "$store.state.updateEditAttachmentView": {
      handler(newval, olval) {
        if (newval) {
          this.setListData()
        } else {
        }
      },
      deep: true,
    },

    showAttachmentView(newVal){
      if (newVal) {
        this.setListData()
      } else {
      }
    },
  },
};
</script>

<style lang='less' scoped>
.edit_attachment_bg{
  position: fixed;
  z-index: 999;
}

/* 元素菜单列表开始 */
  .edit_attachment_content {
    z-index: 999;
    position: absolute;
    width: 320px;
    height: 600px;
    float: right;
    overflow-y: auto;
    top: 0px;
    left: 20px;
    background-color: rgb(245, 245, 245);
    border-radius: 0 0 6px 6px;
    box-sizing: border-box;
    border-left: 1px solid #f0f0f0;
    border-right: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
    user-select: none;
    box-shadow: 0px 2px 5px #999;
    .attachment-title-content {
      width: 100%;
      height: 55px;
      margin-top: 10px;
      text-align: center;
      align-content: center;
      .attachment-title {
        width: 100%;
        height: 100%;
        font-size: 16px;
        font-weight: 700;
        color: #111111;
        text-align: center;
        align-content: center;
      }
      .view_close{
        position: absolute;
        right: 20px;
        top: 12px;
        font-size: 18px;
        color: #222222;
      }
      .view_add {
        position: absolute;
        left: 20px;
        top: 12px;
        font-size: 18px;
        color: #000000;
      }
    }
    .empty-view {
      color: #888888;
      text-align: center;
      font-size: 14px;
      margin-top: 100px;
    }
    
    .list-content-cell {
      height: 55px;
      cursor: pointer;
      .complie-content-icon-box {
        display: flex;
        align-items: center;
        height: 55px;
      }
      .cell-icon {
        width: 24px;
        height: 27px;
        margin-left: 20px;
      }
      .file-layout {
        width: 200px;
        margin-left: 10px;
      }
      .file-name {
        width: 200px;
        margin-left: 0px;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #333333;
      }
      .file-des {
        width: 200px;
        margin-left: 0px;
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #888888;
      }
      .delete_label {
        position:absolute;
        right: 15px;
        cursor: pointer;
        margin-left: 80px;
        font-size: 12px;
        color: #888888;
      }
      .delete_label:hover {
        color: #fb5639;
        font-weight: 800;
      }
      .delete_icon {
        position: relative;
        right: -15px;
        // top: 12px;
        font-size: 18px;
        color: #222222;
      }
    }
    .list-content-cell-activate {
      cursor: pointer;
    }
    .list-content-cell-dark {
      background: #f0f0f0;
    }
    .list-content-cell-light {
      background: #ffffff;
    }
    .list-content-cell-dark:hover {
      background: #e9e9e9;
    }
    .list-content-cell-light:hover {
      background: #e9e9e9;
    }
  }
</style>